<template>
    <div class="align-middle cart-time-info grid-x align-justify">
        <div class="cell auto">
            <p class="display-large color-dark-gray cart-title semi-bold">Schedule for {{ retrievalMethod.toLowerCase() }}</p>
        </div>
        <div class="cell shrink">
            <p class="cart-edit cart-title "><a @click="openOrderParameters">Edit</a></p>
        </div>
        <div class="cell">
            <p class="color-battleship-gray margin-bottom-0" v-if="slotsAvailable">{{ pickupTime }}</p>
            <alert v-if="!isRetrievalMethodOpen" :type="AlertType.WARNING" :title="retrievalMethod + ' is no longer available'">
                <p>Sorry, {{ retrievalMethod.toLowerCase() }} is not available within these hours. <a class="text-underline" @click.prevent="openOrderParameters">Please select another time/retrieval method</a></p>
            </alert>
            <alert :type="AlertType.WARNING" title="Online orders unavailable" v-if="!slotsAvailable">
                <p>Sorry, we cannot take any new orders at this time.</p>
            </alert>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import TimeSchedulerModule, { OrderRetrievalMethod } from '@/stores/modules/time-scheduler';
import { getModule } from 'vuex-module-decorators';
import Alert from '@/components/common/ui/Alert.vue';
import { AlertType } from '@/utils/types';
import TimeSlot, { TimeSlotState } from '@/models/time-slot';

@Component({components: { Alert }})
export default class CartTimeInfo extends Vue
{
    timeSchedulerModule!: TimeSchedulerModule;

    created() {
        this.timeSchedulerModule = getModule(TimeSchedulerModule, this.$store);
    }

    openOrderParameters() {
        this.timeSchedulerModule.setTimeModalOpen(true);
    }

    get isRetrievalMethodOpen() {
        return this.timeSchedulerModule.isRetrievalMethodAvailable();
    }

    get retrievalMethod() {
        return (this.timeSchedulerModule.retrievalMethod === OrderRetrievalMethod.PICK_UP) ? 'Pick-up' : 'Delivery';
    }

    get slotsAvailable() {
        return this.timeSchedulerModule.timeSlots.filter((timeSlot: TimeSlot) => timeSlot.state === TimeSlotState.AVAILABLE).length > 0;
    }

    get pickupTime() {
        return this.timeSchedulerModule.pickupTime;
    }

    get AlertType() {
        return AlertType;
    }
}
</script>
